import { useQuery } from "@tanstack/react-query";
import { getHotelExtrasForSelect } from "../../api/apiHotelExtras";
import i18next from "i18next";

const useGetHotelExtrasForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["HotelExtrasForSelect", i18next.language],
        queryFn: getHotelExtrasForSelect,
        staleTime: 1000 * 60 * 30,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetHotelExtrasForSelect;
